// Пункт меню з попапом — це <a href="#" class="open-modal" data-id="…">
// (NMHG_Nav_Menu_Markup::popup_attributes()). Саме відкриття робить main.js:
// контракт '.open-modal' + 'data-id' у нього вже є, дублювати його тут
// нічого. А от переходу він не скасовує — і не мусив: у кнопок це
// <button type="button">, якому скасовувати нема чого. Посилання ж без
// preventDefault() стрибнуло б угору сторінки й лишило '#' в адресному
// рядку — рівно те, через що тригером модалки й обрали <button>.
//
// Делегування на document, а не слухач на кожному вузлі: головне меню
// друкується двічі (хедер і мобільне), а обробник має пережити будь-яку
// підміну розмітки — включно з пунктом, який з'явився після завантаження.
//
// Іде ПІСЛЯ main.js: порядок для preventDefault() не значущий (обидва
// слухачі відпрацюють до дії за замовчуванням), але тримаємо його таким
// самим, як у решти хелперів, — main.js завжди перший.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a.open-modal[data-id]');

  if (trigger) {
    event.preventDefault();
  }
});
